import { motion } from 'framer-motion';

const Button = ({ 
  variant = 'lime', 
  children, 
  onClick, 
  type = 'button',
  className = '',
  ariaLabel 
}) => {
  const baseStyles = "px-8 py-4 rounded-lg font-medium text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    navy: "bg-navy hover:bg-[#2A5A75] focus:ring-navy",
    lime: "bg-lime hover:bg-[#4A7625] focus:ring-lime"
  };

  return (
    <motion.button
      type={type}
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${className}`}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      aria-label={ariaLabel || children}
    >
      {children}
    </motion.button>
  );
};

export default Button;
